module.exports = __webpack_public_path__ + "static/media/artist.e6d7bcff.png";